import React, { useRef } from 'react'
import styles from './Home.module.css'
import bg2 from '../../asssists/BGVD.mp4'
import Flickity from 'react-flickity-component'
import HomeSecond from '../HomeSecond/HomeSecond'
import HomeThird from '../HomeThird/HomeThird'
import { useGSAP } from '@gsap/react'
import gsap from 'gsap'
import HomeFourth from '../HomeFourth/HomeFourth'
import Footer from '../Footer/Footer'
import FirstBg from '../FirstBg/FirstBg'
const images = require.context(`../../asssists/logos`,true);
const imagesList = images.keys().map((image) => images(image))

export default function Home() {
  let container = useRef();
  let first =  useRef();
  let second =  useRef();
  let third =  useRef();
  let fourth =  useRef();
  let fifth =  useRef();

useGSAP(() => {
 let tl=gsap.timeline();
 tl.fromTo(first.current, {
  opacity: 0,
  y: 200
 }, {
  opacity: 1,
  y: 0,
  duration: 3,
 })

 tl.fromTo(second.current, {
  opacity: 0,
  y: 220
 }, {
  opacity: 1,
  y: 0,
  duration:1,
 })
 tl.fromTo(third.current, {
  opacity: 0,
  y: 240
 }, {
  opacity: 1,
  y: 0,
  duration: 0,
 })
 tl.fromTo(fourth.current, {
  opacity: 0,
  y: 260
 }, {
  opacity: 1,
  y: 0,
  duration: 0,
 })
 tl.fromTo(fifth.current, {
  opacity: 0,
  x: -200
 }, {
  opacity: 1,
  x: 0,
  duration: 0.2,
 })


},{scope:container})


  const flickityOptions = {
    initialIndex: 1,
    autoPlay: true,
    wrapAround: true,
    prevNextButtons: false,
    pageDots: false,
}
  return (
    <>
 <FirstBg/>
  <section className={styles.home}>
  <div className={styles.homeBox}>
    <div ref={container}>
      <div className='row'>
        <div className={`col-md-12 p-5 text-center ${styles.homeContent}`}>
        <h4 ref={first} className='mb-2 fs-1'>Welcome To our official website</h4>
<h3 ref={second} className='mt-2 fs-4'>Take your processes to the next dimension</h3>
<div className="d-flex mt-2">
<p ref={third} className="fs-4 text-center w-100">We Provide Webservices & animations &Games to make your life easier  </p>
</div>


        <div className={styles.box}>
        <video  src={bg2} className={styles.firstVDView} autoPlay loop muted></video>
        </div> 
        <p className='mt-4 fs-4'>THESE SOME OF OUR SKILLS AND WHAT WE OFFER</p>
<Flickity
className={styles.carousel} // default ''
elementType={'div'} // default 'div'
options={flickityOptions} // takes flickity options {}
disableImagesLoaded={false} // default false
reloadOnUpdate // default false
static // default false

>

{imagesList.map((image, index) => (
  <img key={index} src={image} alt="" width={80} height={80} />
))}
</Flickity>
 
        </div>
        
      </div>
    </div>
  <HomeSecond/>
  <HomeFourth/>
  <HomeThird/>
  <Footer/>
    </div>
  </section>

    </>
  )
}

